// Los ajustes calculados a partir de un precio arrastran decimales (-10.0000001), por eso se compara con tolerancia
const YIELD_TOLERANCE = 0.0001

export const isSameYield = (yieldA: number, yieldB: number) => Math.abs(yieldA - yieldB) < YIELD_TOLERANCE
